import React, { useEffect, useState, useRef } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import { updateBranding } from '../../helper';
import { Colors } from '../../themes/Colors';
import TextBase from '../../common/text';
import { translate } from '../../helper';
import APIManager from '../../connection/ApiManager';
import ThemeDesign from '../../component/ThemeDesign';
import ScreenDesign from '../../component/ScreenDesign';
import TemplateDesign from '../../component/TemplateDesign';
import Utils from '../../utils';
import { useSelector } from 'react-redux';
import LocalStorage from '../../defined/localStorage';
import countries from "../../utils/countries.json"
import Api from "../../utils/api";
import PreviewModal from "../../component/PreviewModal"
import { copyUrlToClipboard } from '../../utils/CommonFunction';
import { ENV } from '../../Env';
import BusinessInformation from '../../component/BusinessInformation'
import { ReactComponent as FileCopy } from '../../assets/image/svg/fileCopy.svg'
import mobileSvg from '../../assets/image/svg/mobile.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import EngineeringIcon from '@mui/icons-material/Engineering';
import {
    Info,
    Language,
    PhoneAndroid,
    Email,
    Assignment,
    Share
} from '@mui/icons-material';
import PageTitleHeader from '../../common/page-title-header';


const brand = JSON.parse(LocalStorage.getItem('branding'))


const styles = StyleSheet.create({
    container: {
        textAlign: 'left',
        whiteSpace: 'pre-line',
        position: 'relative',
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-md2)*1)',
    }
});

const brandColor = '#F8B218';

const tabContainerStyle = {
    borderRadius: 'calc(var(--sp-md2)*1.50943)',
    boxShadow: '0 4px 20px rgba(248, 178, 24, 0.08)',
    position: 'relative',
    overflow: 'visible !important',
    width: 'fit-content',
    gap: 'var(--sp-md2)'
};

const tabStyle = (index, value) => ({
    fontSize: 'calc(var(--fs-xs)*1.4150943)',
    fontWeight: value === index ? 600 : 500,
    textTransform: 'none',
    color: value === index ? '#FFFFFF' : '#6B7280',
    backgroundColor: value === index ? brandColor : '#ECECEC',

    borderRadius: 'calc(var(--sp-md2)*1.132075)',
    padding: 'var(--sp-md2) calc(var(--sp-md2)*1.698113)',
    minHeight: 'calc(var(--fs-hero)*1.226415)',
    position: 'relative',
    maxWidth: 'fit-content',
    overflow: 'visible',

    boxShadow: value === index
        ? '0 6px 16px rgba(248, 178, 24, 0.25)'
        : '0 1px 4px rgba(0, 0, 0, 0.05)',

    transition: 'all 0.25s ease',
    '&.Mui-selected': {
        color: '#FFFFFF',
        backgroundColor: brandColor
    },

    '&:hover': {
        backgroundColor: value !== index ? '#E5E7EB' : brandColor,
        transform: 'translateY(-1px)',
    },

    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 'calc(var(--sp-xxs)*-2)',
        left: '50%',
        transform: 'translateX(-50%)',
        borderLeft: 'var(--sp-md2) solid transparent',
        borderRight: 'var(--sp-md2) solid transparent',
        borderTop: value === index ? `var(--sp-md2) solid ${brandColor}` : 'none',
    }
});

const iconStyle = (index, value) => ({
    marginRight: 'var(--sp-md2)',
    fontSize: 'calc(var(--fs-xl)*1.037736)',
    color: value === index ? '#FFFFFF' : '#475569'
});


const defaultColor = { r: "0", g: "0", b: "0", a: "1" }
const backgrounfDefaultColor = { r: "255", g: "255", b: "155", a: "1" }

function CustomTabPanel(props) {
    const { children, value, index, containerSx, containerStyle, typographyStyle, whiteLabel, brand, borderTopColor: propBorderTopColor, ...other } = props;
    const borderTopColor = propBorderTopColor || whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)';

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={containerSx ?? { p: 'calc(var(--sp-lg)*1.32075)' }} style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "calc(var(--sp-md2)*1.886)", ...(containerStyle || {}) }}>
                    <Typography style={{ width: "80%", padding: "calc(var(--sp-lg)*1.415094)", backgroundColor: "#fff", borderRadius: "calc(var(--sp-md2)*1.5)", border:containerSx ? 'none' : "1px solid rgba(0, 0, 0, 0.06)", borderTop: containerSx ? 'none' : `calc(var(--fs-xs)*0.377) solid ${borderTopColor}`, boxShadow: containerSx ? 'none' : "0 2px 8px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.08), 0 8px 24px rgba(0, 0, 0, 0.04)", ...(typographyStyle || {}) }}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    containerSx: PropTypes.object,
    containerStyle: PropTypes.object,
    typographyStyle: PropTypes.object,
    whiteLabel: PropTypes.object,
    brand: PropTypes.object,
    borderTopColor: PropTypes.string,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const defaultFields = [
    {
        name: 'order_name',
        label: translate("orderName"),
        require: true,
        rows: 1,
        default: true
    },
    {
        name: 'description',
        label: translate("description"),
        require: false,
        rows: 2,
        default: true
    },
    {
        name: 'shipping_address',
        label: translate('shippingAddress'),
        require: false,
        rows: 1,
        default: true
    },
    {
        name: 'vin',
        label: translate("numberScanner"),
        require: false,
        rows: 1,
        default: true
    }
]

function getUniqueObjectsByProperty(arr, prop) {
    const uniqueSet = new Set();
    return Array.from(arr.reduce((acc, obj) => {
        if (!uniqueSet.has(obj[prop])) {
            uniqueSet.add(obj[prop]);
            acc.push(obj);
        }
        return acc;
    }, []));
}

function WhiteLabel() {
    const whiteLabel = useSelector((state) => state.User?.branding);
    const userInfo = useSelector((state) => state?.User?.userInfo);
    const isTeamMember = userInfo?.profile?.team_member;
    const borderTopColor = whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)';
    const [value, setValue] = useState(0);
    const [sideBannerColor, setSideBannerColor] = useState(defaultColor);
    const [topBannerColor, setTopBannerColor] = useState(defaultColor);
    const [backgroundColor, setBackgroundColor] = useState(backgrounfDefaultColor);
    const [buttonColor, setButtonColor] = useState(defaultColor);
    const [logo, setLogo] = useState()
    const [logoError, setLogoError] = useState('')
    const [lockForChild, setLockForChild] = useState(true)
    const [screenNames, setScreenNames] = useState({
        screen1: 'Make. Ordering. Very. Easy',
        screen2: 'Picture Perfect Ordering',
        screen3: 'Move'
    })
    const [screenFiles, setScreenFiles] = useState({
        screen1: '',
        screen2: '',
        screen3: ''
    })
    const [mobileTopBannerColor, setMobileTopBannerColor] = useState(defaultColor);
    const [mobileBackgroundColor, setMobileBackgroundColor] = useState(defaultColor);
    const [mobileButtonColor, setMobileButtonColor] = useState(defaultColor);
    const [mobileLogo, setMobileLogo] = useState()
    const [lockForMobChild, setLockForMobChild] = useState(true)
    const [emailLogo, setEmailLogo] = useState();
    const [emailTemplate, setEmailTemplate] = useState({
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: '',
        country: '',
        zipcode: '',
        contact_number: '',
    })
    const [emailBackgroundColor, setEmailBackgroundColor] = useState(defaultColor)
    const [orderBackgroundColor, setOrderBackgroundColor] = useState(backgrounfDefaultColor)
    const [orderForm, setOrderForm] = useState(defaultFields)
    const [orderType, setOrderType] = useState('')
    const [currencyType, setCurrencyType] = useState('')
    const [orderFormCustomer, setOrderFormCustomer] = useState(defaultFields)
    const [orderFormDealer, setOrderFormDealer] = useState(defaultFields)
    const [currencyTypeCustomer, setCurrencyTypeCustomer] = useState('')
    const [currencyTypeDealer, setCurrencyTypeDealer] = useState('')
    const [loading, setLoading] = useState(false)
    const [showPreview, setShowPreview] = useState({
        status: false,
        type: ''
    })
    const [sendingLink, setSendingLink] = useState(false)
    const [copiedIndex, setCopiedIndex] = useState(null)
    const [copiedIndexTop, setCopiedIndexTop] = useState(null)
    const copyTimeoutRef = useRef(null)
    const copyTimeoutRefTop = useRef(null)
    let currencies = [...getUniqueObjectsByProperty(countries, 'currency')]

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const setDefault = () => {
        getWhitelabelData(value)
        window.scrollTo(0, 0);
    }

    const setWelcomeScreenDefault = () => {
        getWhitelabelData(value)
        window.scrollTo(0, 0);
    }

    const setEmailTeplateDefault = () => {
        if (value === 3) {
            getEmailTemplate()
        }
        if (value === 4) {
            getDynamicAttributeData()
        }
    }

    useEffect(() => {
        document.title = 'White Labeling';
    }, []);

    const rgbaToHex = (color) => {
        const rgba = Object.values(color);
        let hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
            .toString(16)
            .slice(1)}`;

        return hex;
    };

    const saveThemeChanges = async () => {
        try {

            const formData = new FormData()
            if (value === 1) {
                if (!logo) {
                    setLogoError("Please upload a logo!!")
                    Utils.showAlert(2, 'Please upload a logo!!')
                    return
                }
                setLoading(true)
                if (logo instanceof File) {
                    formData.append('web_logo', logo)
                }
                formData.append('web_top_banner_color', rgbaToHex(topBannerColor))
                formData.append('web_side_banner_color', rgbaToHex(sideBannerColor))
                formData.append('web_background_color', rgbaToHex(backgroundColor))
                formData.append('web_button_color', rgbaToHex(buttonColor))
                formData.append('is_branding', lockForChild)
            }
            if (value === 2) {
                if (!mobileLogo) {
                    setLogoError("Please upload a logo!!")
                    return
                }
                formData.append('mobile_screen_1_text', screenNames.screen1)
                if (screenFiles.screen1 instanceof File) {
                    formData.append('mobile_screen_1_image', screenFiles.screen1)
                }
                formData.append('mobile_screen_2_text', screenNames.screen2)
                if (screenFiles.screen2 instanceof File) {
                    formData.append('mobile_screen_2_image', screenFiles.screen2)
                }
                formData.append('mobile_screen_3_text', screenNames.screen3)
                if (screenFiles.screen3 instanceof File) {
                    formData.append('mobile_screen_3_image', screenFiles.screen3)
                }
                if (mobileLogo instanceof File) {
                    formData.append('mobile_logo', mobileLogo)
                }
                formData.append('mobile_top_banner_color', rgbaToHex(mobileTopBannerColor))
                formData.append('mobile_background_color', rgbaToHex(backgrounfDefaultColor))
                formData.append('mobile_button_color', rgbaToHex(mobileButtonColor))
                formData.append('is_branding', lockForChild)
            }

            const resOrder = await APIManager.getInstance().updateTheme(formData);

            await updateBranding()
            Utils.showAlert(1, 'Successfully updated!!!')
            LocalStorage.removeItem('branding')
            setLoading(false)
            setShowPreview({ status: false, type: '' })
            if (value === 1) {
                setTimeout(() => {
                    window.location.reload();
                    window.location.reload();
                }, 1000)
            }
        } catch (err) {
            console.log(err)
            let errProperty = Object.keys(err)[0]
            let errMessage = err[errProperty]?.[0]
            setLoading(false)
            Utils.showAlert(2, `${errProperty} - ${errMessage}` || 'Something went wrong')
        }
    }

    const sendSetUpLink = async () => {
        setSendingLink(true)
        try {
            let res = await APIManager.getInstance().sendSetUpLink();
            if (res?.data?.message) {
                Utils.showAlert(1, res?.data?.message || 'Successfully link send!')
                setSendingLink(false)
            }
        } catch (err) {
            console.error(err)
            Utils.showAlert(2, err?.data || 'Something went wrong')
            setSendingLink(false)
        }
    }

    const buildOrderFormPayload = (formState, currency, order_form_type) => {
        const getLabelByName = (key) => (
            formState.find(f => f.default && f.name === key)?.label
            || defaultFields.find(d => d.name === key)?.label
        );

        const fixed_attribute_display_names = {
            order_name: getLabelByName('order_name'),
            description: getLabelByName('description'),
            shipping_address: getLabelByName('shipping_address'),
            vin: getLabelByName('vin'),
        };

        const nonRemovableDefaultLabels = defaultFields
            .filter(d => !d.removabale)
            .map(d => d.label);

        const dynamic_attribute_names = formState
            .filter(item => !nonRemovableDefaultLabels.includes(item.label))
            .filter(item => !item.default)
            .map(e => ({ name: e.label, mandatory: e.mandatory }));

        return {
            background_color: "#fff",
            currency_type: currency,
            fixed_attribute_display_names,
            dynamic_attribute_names,
            order_form_type,
        };
    };

    const saveOrderFormCustomer = async () => {
        const payload = buildOrderFormPayload(orderFormCustomer, currencyTypeCustomer, 1);
        await Api.postApiCall('white-labels/create-order-form/', JSON.stringify(payload))
        Utils.showAlert(1, 'Successfully updated (Customer)!!!')
        setTimeout(() => {
            getDynamicAttributeData()
            setValue(4)
            setShowPreview({ status: false, type: '' })
        }, 1000)
    };

    const saveOrderFormDealer = async () => {
        const payload = buildOrderFormPayload(orderFormDealer, currencyTypeDealer, 2);
        await Api.postApiCall('white-labels/create-order-form/', JSON.stringify(payload))
        Utils.showAlert(1, 'Successfully updated (Dealer)!!!')
        setTimeout(() => {
            getDynamicAttributeData()
            setValue(4)
            setShowPreview({ status: false, type: '' })
        }, 1000)
    };

    const saveTemplate = async () => {
        try {
            if (value === 3) {

            }
            const formData = new FormData()
            formData.append('address_line_1', emailTemplate.address_line_1)
            formData.append('address_line_2', emailTemplate.address_line_2)
            formData.append('country', emailTemplate.country)
            formData.append('city', emailTemplate.city)
            formData.append('state', emailTemplate.state)
            formData.append('zip_code', emailTemplate.zipcode)
            formData.append('contact_number', emailTemplate.contact_number)
            formData.append('background_color', rgbaToHex(emailBackgroundColor))
            if (emailLogo instanceof File) {
                formData.append('template_logo', emailLogo)
            }

            const resOrder = await APIManager.getInstance().updateEmailTemplate(formData)
            if (resOrder?.data?.id) {
                Utils.showAlert(1, 'Successfully updated!!!')
                setTimeout(() => {
                    getDynamicAttributeData()
                    getEmailTemplate()
                    setValue(3)
                    setShowPreview({ status: false, type: '' })
                }, 1000)
            } else {
                throw new Error()
            }

        } catch (err) {
            Utils.showAlert(2, err?.message || 'Something went wrong')
        }
    }

    function hexToRGB(hex, alpha) {

        if (!hex) {
            return null;
        }
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        return { r, g, b, a: "1" };

    }

    const getDynamicAttributeData = async () => {
        const resOrder = await APIManager.getInstance().getDynamicAttributes();
        setOrderBackgroundColor("#fff")

        const list = Array.isArray(resOrder?.data) ? resOrder.data : (resOrder?.data ? [resOrder.data] : []);

        const byType = (type) => list.find((d) => Number(d?.order_form_type) === Number(type)) || {};

        const customer = byType(1);
        const dealer = byType(2);

        const buildForm = (cfg) => {
            const fixedDisplay = cfg?.fixed_attribute_display_names || {};
            const defaultsWithApiLabels = defaultFields.map((df) => ({
                ...df,
                label: fixedDisplay?.[df.name] || df.label,
            }));
            const dynamicRaw = cfg?.dynamic_attribute_names || [];
            const dedupedDynamic = dynamicRaw.filter((value, index, self) =>
                index === self.findIndex((t) => t.name === value.name)
            );
            const defaultLabels = defaultsWithApiLabels.map(e => e.label);
            const filteredDynamic = dedupedDynamic.filter(e => !defaultLabels.includes(e.name));
            return [
                ...defaultsWithApiLabels,
                ...(filteredDynamic.map(e => ({ ...e, label: e.name })) || [])
            ];
        };

        setCurrencyTypeCustomer(customer?.currency_type || '')
        setCurrencyTypeDealer(dealer?.currency_type || '')

        const customerForm = buildForm(customer);
        const dealerForm = buildForm(dealer);

        setOrderFormCustomer(customerForm)
        setOrderFormDealer(dealerForm)

        // Keep legacy single-form state aligned with Customer for backwards compatibility
        setCurrencyType(customer?.currency_type || '')
        setOrderForm(customerForm)
    }

    async function getEmailTemplate() {
        const resOrder = await APIManager.getInstance().gateEmailTemplate()
        setEmailTemplate({
            address_line_1: resOrder?.data?.address_line_1 || '',
            address_line_2: resOrder?.data?.address_line_2 || '',
            city: resOrder?.data?.city || '',
            state: resOrder?.data?.state || '',
            country: resOrder?.data?.country || '',
            zipcode: resOrder?.data?.zip_code || '',
            contact_number: resOrder?.data?.contact_number || '',
        })
        setEmailBackgroundColor(hexToRGB(resOrder?.data?.background_color) || "#000")
        setEmailLogo(resOrder?.data?.template_logo || null)
    }

    async function getWhitelabelData(val) {
        const resOrder = await APIManager.getInstance().getWhitelabel();
        const data = resOrder?.data || {}
        if (val === 1) {
            setSideBannerColor(hexToRGB(data?.web_side_banner_color) || defaultColor)
            setTopBannerColor(hexToRGB(data?.web_top_banner_color) || defaultColor)
            setBackgroundColor(hexToRGB(data?.web_background_color) || backgrounfDefaultColor)
            setButtonColor(hexToRGB(data?.web_button_color) || defaultColor)
            setLogo(data?.web_logo || null)
        }
        if (val === 2) {
            setScreenNames({
                screen1: data?.mobile_screen_1_text || 'Make. Ordering. Very. Easy',
                screen2: data?.mobile_screen_2_text || 'Picture Perfect Ordering',
                screen3: data?.mobile_screen_3_text || 'Move'
            })
            setScreenFiles({
                screen1: data?.mobile_screen_1_image || '',
                screen2: data?.mobile_screen_2_image || '',
                screen3: data?.mobile_screen_3_image || ''
            })
            setMobileTopBannerColor(hexToRGB(data?.mobile_top_banner_color) || defaultColor)
            setMobileBackgroundColor(hexToRGB(data?.mobile_background_color) || backgrounfDefaultColor)
            setMobileButtonColor(hexToRGB(data?.mobile_button_color) || defaultColor)
            setMobileLogo(data?.mobile_logo || null)
        }
        if (!val) {
            setSideBannerColor(hexToRGB(data?.web_side_banner_color) || defaultColor)
            setTopBannerColor(hexToRGB(data?.web_top_banner_color) || defaultColor)
            setBackgroundColor(hexToRGB(data?.web_background_color) || backgrounfDefaultColor)
            setButtonColor(hexToRGB(data?.web_button_color) || defaultColor)
            setLogo(data?.web_logo || null)
            setScreenNames({
                screen1: data?.mobile_screen_1_text || 'Make. Ordering. Very. Easy',
                screen2: data?.mobile_screen_2_text || 'Picture Perfect Ordering',
                screen3: data?.mobile_screen_3_text || 'Move'
            })
            setScreenFiles({
                screen1: data?.mobile_screen_1_image || '',
                screen2: data?.mobile_screen_2_image || '',
                screen3: data?.mobile_screen_3_image || ''
            })
            setMobileTopBannerColor(hexToRGB(data?.mobile_top_banner_color) || defaultColor)
            setMobileBackgroundColor(hexToRGB(data?.mobile_background_color) || backgrounfDefaultColor)
            setMobileButtonColor(hexToRGB(data?.mobile_button_color) || defaultColor)
            setMobileLogo(data?.mobile_logo || null)
        }
        setLockForChild(data?.is_branding)
    }

    useEffect(() => {
        if (!isTeamMember) {
            getWhitelabelData()
            getDynamicAttributeData()
            getEmailTemplate()
        }
    }, [])

    const addFIeld = () => {
        const maxId = orderForm.reduce((prev, current) => {
            const curId = typeof current.id === 'number' ? current.id : 0;
            return curId > prev ? curId : prev;
        }, 0);
        setOrderForm([...orderForm, { id: maxId + 1, label: '', mandatory: false }]);
    }

    const addFieldFor = (target) => {
        const form = target === 'dealer' ? orderFormDealer : orderFormCustomer;
        const setter = target === 'dealer' ? setOrderFormDealer : setOrderFormCustomer;
        const maxId = form.reduce((prev, current) => {
            const curId = typeof current.id === 'number' ? current.id : 0;
            return curId > prev ? curId : prev;
        }, 0);
        setter([...form, { id: maxId + 1, label: '', mandatory: false }]);
    };

    const onLabelChangeFor = (target, key, val) => {
        const form = target === 'dealer' ? orderFormDealer : orderFormCustomer;
        const setter = target === 'dealer' ? setOrderFormDealer : setOrderFormCustomer;
        const newForm = form.map((order) => {
            const match = (typeof key === 'number' && typeof order.id === 'number' && order.id === key)
                || (typeof key === 'string' && order?.name === key);
            if (match) {
                return { ...order, label: val };
            }
            return order;
        });
        setter(newForm);
    };

    const deleteLabelFor = (target, id) => {
        const form = target === 'dealer' ? orderFormDealer : orderFormCustomer;
        const setter = target === 'dealer' ? setOrderFormDealer : setOrderFormCustomer;
        setter(form.filter(e => e.id !== id));
    };

    const mandatoryFieldChangeFor = (target, id) => {
        const form = target === 'dealer' ? orderFormDealer : orderFormCustomer;
        const setter = target === 'dealer' ? setOrderFormDealer : setOrderFormCustomer;
        const newForm = form.map(e => {
            if (e.id === id) {
                e.mandatory = !e.mandatory;
            }
            return e;
        });
        setter(newForm);
    };

    const onLabelChange = (key, val) => {
        const newForm = orderForm.map((order) => {
            const match = (typeof key === 'number' && typeof order.id === 'number' && order.id === key)
                || (typeof key === 'string' && order?.name === key);
            if (match) {
                return { ...order, label: val };
            }
            return order;
        });
        setOrderForm(newForm);
    }
    const deleteLabel = (id) => {
        let newFOrm = orderForm.filter(e => e.id !== id)
        setOrderForm(newFOrm)
    }
    const mandatoryFieldChange = (id) => {
        const newOrderForm = orderForm.map(e => {
            if (e.id === id) {
                e.mandatory = !e.mandatory
            }
            return e
        })
        setOrderForm(newOrderForm)
    }

    const handleClosePreview = () => {
        setShowPreview({ status: false, type: '' })
    }

    const [previewTarget, setPreviewTarget] = useState('customer')
    const [expandedOrderPanel, setExpandedOrderPanel] = useState('customer')
    const handleOrderAccordionChange = (panel) => (event, isExpanded) => {
        if (isExpanded) {
            setExpandedOrderPanel(panel);
        } else {
            setExpandedOrderPanel(panel === 'customer' ? 'dealer' : 'customer');
        }
    };
    const checkPreview = (target) => {
        if (value === 1) {
            if (!logo) {
                setLogoError("Please upload a logo!!")
                Utils.showAlert(2, 'Please upload a logo!!')
                return
            }
            setShowPreview({ status: true, type: 'web' })
        }
        if (value === 2) {
            if (!mobileLogo) {
                setLogoError("Please upload a logo!!")
                return
            }
            setShowPreview({ status: true, type: 'mob' })
        }
        if (value === 3) {
            setShowPreview({ status: true, type: 'email' })
        }
        if (value === 4) {
            setPreviewTarget(target === 'dealer' ? 'dealer' : 'customer')
            setShowPreview({ status: true, type: 'order' })
        }
    }

    const savePreviewData = () => {
        if (value === 1) {
            saveThemeChanges()
        }
        if (value === 2) {
            saveThemeChanges()
        }
        if (value === 3) {
            saveTemplate()
        }
        if (value === 4) {
            if (previewTarget === 'dealer') {
                saveOrderFormDealer()
            } else {
                saveOrderFormCustomer()
            }
        }

    }

    const domainList = [
        // { url: `${ENV.API_URL}/admin/login/?next=/admin/`, label: 'Admin URL' },
        { url: `${ENV.API_URL}/customer`, label: 'Customer Application URL' },
        { url: `${ENV.API_URL}/dealer-technician`, label: 'Dealer Technician URL' },
        // { url: `${ENV.API_URL}/login`, label: 'White Label Application URL' }
    ];

    return (
        <div style={{ backgroundColor: "#fff" }} className={css(styles.container)}>
            <PageTitleHeader
                title={translate('branding')}
                containerStyle={{ marginBottom: 'calc(var(--sp-lg)*2.83018)' }}
            />
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{ style: { display: 'none' } }}
                    sx={{
                        overflow: "visible",
                        '& .MuiTabs-scroller': { overflow: "visible !important" },
                        '& .MuiTabs-flexContainer': tabContainerStyle
                    }}
                >
                    {!isTeamMember && <Tab icon={<Info sx={iconStyle(0, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(0, value)} label={translate("businessInformation")} {...a11yProps(0)} />}
                    {!isTeamMember && <Tab icon={<Language sx={iconStyle(1, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(1, value)} label={translate("Web")} {...a11yProps(1)} />}
                    {!isTeamMember && <Tab icon={<PhoneAndroid sx={iconStyle(2, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(2, value)} label={translate("mobile")} {...a11yProps(2)} />}
                    {!isTeamMember && <Tab icon={<Email sx={iconStyle(3, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(3, value)} label={translate("emailTemplateOrderForm")} {...a11yProps(3)} />}
                    {!isTeamMember && <Tab icon={<Assignment sx={iconStyle(4, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(4, value)} label={translate("orderForm")} {...a11yProps(4)} />}
                    <Tab icon={<Share sx={iconStyle(isTeamMember ? 0 : 5, value)} />} iconPosition="start" TabIndicatorProps={{ style: { background: '#F8B218' } }} sx={tabStyle(isTeamMember ? 0 : 5, value)} label={translate("distributionLinks")} {...a11yProps(isTeamMember ? 0 : 5)} />
                </Tabs>
                {!isTeamMember && <CustomTabPanel value={value} index={0} whiteLabel={whiteLabel} brand={brand} borderTopColor={borderTopColor}>
                    <BusinessInformation />
                </CustomTabPanel>}
                {!isTeamMember && <CustomTabPanel value={value} index={1} whiteLabel={whiteLabel} brand={brand} borderTopColor={borderTopColor}>
                    <ThemeDesign
                        header={true}
                        topBanner={true}
                        sideBanner={true}
                        button={true}
                        onSubmit={saveThemeChanges}
                        onPreview={checkPreview}
                        onClosePreview={handleClosePreview}
                        sideBannerColor={sideBannerColor}
                        topBannerColor={topBannerColor}
                        backgroundColor={backgroundColor}
                        buttonColor={buttonColor}
                        logo={logo}
                        setSideBannerColor={setSideBannerColor}
                        setTopBannerColor={setTopBannerColor}
                        setBackgroundColor={setBackgroundColor}
                        setButtonColor={setButtonColor}
                        setLogo={setLogo}
                        onCancel={setDefault}
                        active={lockForChild}
                        setActive={setLockForChild}
                        logoError={logoError}
                        setLogoError={setLogoError}
                        loading={loading}
                        send={sendSetUpLink}
                        isSending={sendingLink}
                    />
                </CustomTabPanel>}
                {!isTeamMember && <CustomTabPanel value={value} index={2} whiteLabel={whiteLabel} brand={brand} borderTopColor={borderTopColor}>
                    <ScreenDesign
                        screenNames={screenNames}
                        setScreenNames={setScreenNames}
                        screenFiles={screenFiles}
                        setScreenFiles={setScreenFiles}
                        onSubmit={saveThemeChanges}
                        onPreview={checkPreview}
                        topBannerColor={mobileTopBannerColor}
                        setTopBannerColor={setMobileTopBannerColor}
                        backgroundColor={mobileBackgroundColor}
                        setBackgroundColor={setMobileBackgroundColor}
                        buttonColor={mobileButtonColor}
                        setButtonColor={setMobileButtonColor}
                        logo={mobileLogo}
                        setLogo={setMobileLogo}
                        onCancel={setWelcomeScreenDefault}
                        active={lockForMobChild}
                        setActive={setLockForMobChild}
                        logoError={logoError}
                        setLogoError={setLogoError}
                        loading={loading}
                        send={sendSetUpLink}
                    />
                </CustomTabPanel>}
                {!isTeamMember && <CustomTabPanel value={value} index={3} whiteLabel={whiteLabel} brand={brand} borderTopColor={borderTopColor}>
                    <TemplateDesign
                        tab="emailtemplate"
                        emailLogo={emailLogo}
                        setEmailLogo={setEmailLogo}
                        onPreview={checkPreview}
                        emailTemplate={emailTemplate}
                        setEmailTemplate={setEmailTemplate}
                        emailBackgroundColor={emailBackgroundColor}
                        setEmailBackgroundColor={setEmailBackgroundColor}
                        orderBackgroundColor={orderBackgroundColor}
                        setOrderBackgroundColor={setOrderBackgroundColor}
                        onSubmit={saveTemplate}
                        onCancel={setEmailTeplateDefault}
                        orderForm={orderForm}
                        setOrderForm={setOrderForm}
                        addFIeld={addFIeld}
                        onLabelChange={onLabelChange}
                        orderType={orderType}
                        setOrderType={setOrderType}
                        currencyType={currencyType}
                        setCurrencyType={setCurrencyType}
                        currencies={currencies}
                        deleteLabel={deleteLabel}
                    />
                </CustomTabPanel>}
                {!isTeamMember && <CustomTabPanel value={value} index={4} whiteLabel={whiteLabel} brand={brand} borderTopColor={borderTopColor}>
                    <Accordion expanded={expandedOrderPanel === 'customer'} onChange={handleOrderAccordionChange('customer')} sx={{boxShadow: 'none', border: 'none', borderRadius: 'calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.5) 0 0', '&::before': { display: 'none' }, overflow: 'hidden' }}>
                        <AccordionSummary sx={{ backgroundColor: '#ffffff', border: '1.5px solid #E5E7EB', boxShadow: '0 4px 12px rgba(15, 61, 82, 0.12), 0 1px 3px rgba(0, 0, 0, 0.06)', height: 'calc(var(--fs-hero)*1.57761)', minHeight: 'unset', py: 'calc(var(--sp-md2)*0.5)', px: 'calc(var(--sp-md2)*2)', borderRadius: expandedOrderPanel === 'customer' ? 'calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.5) 0 0' : 'calc(var(--sp-md2)*1.5)', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 8px 20px rgba(15, 61, 82, 0.18), 0 2px 6px rgba(0, 0, 0, 0.1)', borderColor: '#D1D5DB' } }} expandIcon={<ExpandMoreIcon sx={{ fontSize: "calc(var(--fs-xl) * 1.132075)", color: '#0F3D52' }} />} aria-controls="customer-order-form-content" id="customer-order-form-header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1)' }}>
                                <div style={{ backgroundColor: '#F0F5F7', borderRadius: 'calc(var(--sp-md2)*0.8)', padding: 'calc(var(--sp-md2)*0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(15, 61, 82, 0.08)' }}>
                                    <PersonIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.132075)', color: '#0F3D52' }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ fontWeight: 600, fontSize: 'calc(var(--fs-xs) * 1.698113)', color: '#1F2937' }}>Customer</div>
                                    <div style={{ fontWeight: 400, fontSize: 'calc(var(--fs-xs) * 1.13208)', color: '#6B7280', marginTop: 'calc(var(--sp-xxs)*0.5)' }}>Configure order form fields for customer</div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TemplateDesign
                                tab="orderForm"
                                emailLogo={emailLogo}
                                setEmailLogo={setEmailLogo}
                                onPreview={() => checkPreview('customer')}
                                emailTemplate={emailTemplate}
                                setEmailTemplate={setEmailTemplate}
                                emailBackgroundColor={emailBackgroundColor}
                                setEmailBackgroundColor={setEmailBackgroundColor}
                                orderBackgroundColor={orderBackgroundColor}
                                setOrderBackgroundColor={setOrderBackgroundColor}
                                onSubmit={saveOrderFormCustomer}
                                onCancel={setEmailTeplateDefault}
                                orderForm={orderFormCustomer}
                                setOrderForm={setOrderFormCustomer}
                                addFIeld={() => addFieldFor('customer')}
                                onLabelChange={(key, val) => onLabelChangeFor('customer', key, val)}
                                orderType={orderType}
                                setOrderType={setOrderType}
                                currencyType={currencyTypeCustomer}
                                setCurrencyType={setCurrencyTypeCustomer}
                                currencies={currencies}
                                deleteLabel={(id) => deleteLabelFor('customer', id)}
                                mandatoryFieldChange={(id) => mandatoryFieldChangeFor('customer', id)}
                            />
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expandedOrderPanel === 'dealer'} onChange={handleOrderAccordionChange('dealer')} sx={{ marginTop: 'calc(var(--sp-md2)*1.5)', boxShadow: 'none', border: 'none', borderRadius: 'calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.5) 0 0', '&::before': { display: 'none' }, overflow: 'hidden' }}>
                        <AccordionSummary sx={{ backgroundColor: '#ffffff', border: '1.5px solid #E5E7EB', boxShadow: '0 4px 12px rgba(15, 61, 82, 0.12), 0 1px 3px rgba(0, 0, 0, 0.06)', height: 'calc(var(--fs-hero)*1.57761)', minHeight: 'unset', py: 'calc(var(--sp-md2)*0.5)', px: 'calc(var(--sp-md2)*2)', borderRadius: expandedOrderPanel === 'dealer' ? 'calc(var(--sp-md2)*1.5) calc(var(--sp-md2)*1.5) 0 0' : 'calc(var(--sp-md2)*1.5)', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 8px 20px rgba(15, 61, 82, 0.18), 0 2px 6px rgba(0, 0, 0, 0.1)', borderColor: '#D1D5DB' } }} expandIcon={<ExpandMoreIcon sx={{ fontSize: "calc(var(--fs-xl) * 1.132075)", color: '#0F3D52' }} />} aria-controls="dealer-order-form-content" id="dealer-order-form-header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1)' }}>
                                <div style={{ backgroundColor: '#F0F5F7', borderRadius: 'calc(var(--sp-md2)*0.8)', padding: 'calc(var(--sp-md2)*0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(15, 61, 82, 0.08)' }}>
                                    <EngineeringIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.132075)', color: '#0F3D52' }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ fontWeight: 600, fontSize: 'calc(var(--fs-xs) * 1.698113)', color: '#1F2937' }}>Dealer Technician</div>
                                    <div style={{ fontWeight: 400, fontSize: 'calc(var(--fs-xs) * 1.13208)', color: '#6B7280', marginTop: 'calc(var(--sp-xxs)*0.5)' }}>Configure order form fields for technician</div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TemplateDesign
                                tab="orderForm"
                                emailLogo={emailLogo}
                                setEmailLogo={setEmailLogo}
                                onPreview={() => checkPreview('dealer')}
                                emailTemplate={emailTemplate}
                                setEmailTemplate={setEmailTemplate}
                                emailBackgroundColor={emailBackgroundColor}
                                setEmailBackgroundColor={setEmailBackgroundColor}
                                orderBackgroundColor={orderBackgroundColor}
                                setOrderBackgroundColor={setOrderBackgroundColor}
                                onSubmit={saveOrderFormDealer}
                                onCancel={setEmailTeplateDefault}
                                orderForm={orderFormDealer}
                                setOrderForm={setOrderFormDealer}
                                addFIeld={() => addFieldFor('dealer')}
                                onLabelChange={(key, val) => onLabelChangeFor('dealer', key, val)}
                                orderType={orderType}
                                setOrderType={setOrderType}
                                currencyType={currencyTypeDealer}
                                setCurrencyType={setCurrencyTypeDealer}
                                currencies={currencies}
                                deleteLabel={(id) => deleteLabelFor('dealer', id)}
                                mandatoryFieldChange={(id) => mandatoryFieldChangeFor('dealer', id)}
                            />
                        </AccordionDetails>
                    </Accordion>
                </CustomTabPanel>}

                <CustomTabPanel value={value} index={isTeamMember ? 0 : 5} whiteLabel={whiteLabel} brand={brand} containerSx={{ p: 'calc(var(--sp-xxs) * 0.471698)' }} containerStyle={{ justifyContent: 'flex-start', marginTop: 'calc(var(--sp-md2) * 1.69811)' }} typographyStyle={{ padding: 0, width: '100%' }}>
                    <div
                        style={{
                            width: "100%",
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            gap: "calc(var(--sp-md2) * 1.886792)",
                        }}
                    >
                        {domainList.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "calc(var(--sp-xxs) * 2)",
                                    display: "flex",
                                    flexDirection: "column",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                    borderTop: `calc(var(--fs-xs)*0.377) solid ${borderTopColor}`
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "calc(var(--sp-md2) * 1)",
                                        padding:
                                            "calc(var(--sp-md2) * 1.69811) calc(var(--sp-md2) * 1.32075) calc(var(--sp-md2) * 1)",
                                    }}
                                >
                                    {/* Left: Icon + Label */}
                                    <div style={{ display: "flex", alignItems: "center", gap: "var(--sp-sm)" }}>
                                        <div style={{ backgroundColor: '#fff', borderRadius: 'calc(var(--sp-md2)*0.8)', padding: 'calc(var(--sp-md2)*0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                                            {item.label.includes('Customer') ? (
                                                <PersonIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.132075)', color: '#0F5555' }} />
                                            ) : (
                                                <EngineeringIcon sx={{ fontSize: 'calc(var(--fs-xl)*1.132075)', color: '#0F5555' }} />
                                            )}
                                        </div>
                                        <span
                                            style={{
                                                fontSize: "calc(var(--fs-xs)*1.698113)",
                                                color: "rgba(0,0,0,1)",
                                                lineHeight: "calc(var(--sp-lg)*1.273585)",
                                                fontWeight: "600",
                                            }}
                                        >
                                            {item.label}
                                        </span>
                                    </div>

                                    {/* Right: Same-style actions using map */}
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {[
                                            {
                                                label: "Open",
                                                onClick: () => window.open(item.url, "_blank"),
                                            },
                                            {
                                                label: copiedIndexTop === index ? "Copied" : "Copy",
                                                onClick: async () => {
                                                    try {
                                                        await copyUrlToClipboard(item.url)
                                                        setCopiedIndexTop(index)
                                                        if (copyTimeoutRefTop.current) clearTimeout(copyTimeoutRefTop.current)
                                                        copyTimeoutRefTop.current = setTimeout(() => setCopiedIndexTop(null), 2000)
                                                    } catch {
                                                        console.error("Failed to copy URL, trying fallback method.")
                                                    }
                                                },
                                            },
                                        ].map((action, i) => (
                                            <button
                                                key={i}
                                                role="button"
                                                tabIndex={0}
                                                onClick={action.onClick}
                                                style={{
                                                    cursor: "pointer",
                                                    fontWeight: 700,
                                                    color: "#3127a0",
                                                    fontSize: "calc(var(--fs-xs)*1.32075)",
                                                    borderRadius: "calc(var(--sp-md2) * 1.5)",
                                                    userSelect: "none",
                                                    padding: "calc(var(--sp-md2) * 0.7) calc(var(--sp-md2) * 1.2)",
                                                    lineHeight: 'calc(var(--fs-xs)*0.09433)',
                                                    border: "1.5px solid #E5E7EB",
                                                    background: "#F9FAFB",
                                                    transition: 'all 0.3s ease',
                                                    marginRight: i === 0 ? 'calc(var(--sp-md2) * 0.5)' : '0'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.borderColor = "#D1D5DB"
                                                    e.currentTarget.style.backgroundColor = "#F3F4F6"
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.borderColor = "#E5E7EB"
                                                    e.currentTarget.style.backgroundColor = "#F9FAFB"
                                                }}
                                            >
                                                {action.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <p
                                    style={{
                                        color: "rgba(101, 101, 101, 1)",
                                        fontSize: "calc(var(--fs-xs) * 1.50943)",
                                        marginBottom: "calc(var(--sp-md2) * 1.32075)",
                                        lineHeight: "calc(var(--sp-md2) * 1.886792)",
                                        marginLeft: "calc(var(--sp-lg) * 2.9)",
                                        marginRight: "calc(var(--sp-lg) * 2.216981)",
                                        fontWeight: '400'
                                    }}
                                >
                                    This link allows you to share your mobile application with your{" "}
                                    {item.label.includes("Customer")
                                        ? "Customers"
                                        : "Dealer Technicians"}. Simply copy this link and distribute it via
                                    email, text message, or QR code on printed materials.
                                </p>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "#f9fafb",
                                        border: "1px solid #e5e7eb",
                                        borderBottomRightRadius: "var(--sp-sm)",
                                        borderBottomLeftRadius: "var(--sp-sm)",
                                        justifyContent: "space-between",
                                        overflow: "hidden",
                                        padding: "calc(var(--sp-md2) * 0.84905) calc(var(--sp-md2) * 1.4150943) calc(var(--sp-md2) * 1.037735)",

                                    }}
                                >
                                    <span

                                        style={{
                                            border: "none",
                                            outline: "none",
                                            backgroundColor: "transparent",
                                            fontSize: "calc(var(--sp-md2) * 1.32075)",
                                            color: "rgba(0, 0, 0, 0.5)",
                                            width: "100%",
                                            fontWeight: 400,
                                            padding: 0,
                                            lineHeight: "calc(var(--sp-md2) * 1.50943)"
                                        }}
                                    >{item.url}</span>
                                    <div
                                        onClick={async () => {
                                            try {
                                                await copyUrlToClipboard(item.url)
                                                setCopiedIndex(index)
                                                if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current)
                                                copyTimeoutRef.current = setTimeout(() => setCopiedIndex(null), 2000)
                                            } catch (e) {
                                                await copyUrlToClipboard(item.url)
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        style={{
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "calc(var(--sp-md2) * 0.7)",
                                            color: "#3127a0",
                                            fontWeight: 700,
                                            fontSize: "calc(var(--fs-xs) * 1.32075)",
                                            borderRadius: "calc(var(--sp-md2) * 1.5)",
                                            border: "1.5px solid #E5E7EB",
                                            background: "#F9FAFB",
                                            padding: "calc(var(--sp-md2) * 0.7) calc(var(--sp-md2) * 1.2)",
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = "#D1D5DB"
                                            e.currentTarget.style.backgroundColor = "#F3F4F6"
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = "#E5E7EB"
                                            e.currentTarget.style.backgroundColor = "#F9FAFB"
                                        }}
                                    >
                                        <FileCopy style={{ width: "calc(var(--fs-xs) * 1.886792)", height: "calc(var(--fs-xs) * 1.886792)" }} />
                                        <span style={{ userSelect: 'none' }}>{copiedIndex === index ? 'Copied' : translate('copy')}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </CustomTabPanel>
            </Box>
            <PreviewModal
                isOpen={showPreview.status}
                type={showPreview.type}
                onClose={handleClosePreview}
                webTheme={{
                    sideBannerColor,
                    topBannerColor,
                    backgroundColor,
                    buttonColor,
                    logo
                }}
                mobTheme={{
                    screenNames,
                    screenFiles,
                    mobileTopBannerColor,
                    mobileBackgroundColor,
                    mobileButtonColor,
                    mobileLogo
                }}
                orderForm={previewTarget === 'dealer' ? orderFormDealer : orderFormCustomer}
                orderBackgroundColor={orderBackgroundColor}
                emailData={{
                    emailLogo,
                    emailTemplate,
                    emailBackgroundColor,
                }}
                onSubmit={savePreviewData}
                loading={loading}
            />
        </div>
    )
}

export default WhiteLabel
